module.exports = __webpack_public_path__ + "images/52f2cc50d082886ac5ec7d5ceadf19d18177996394afd7fc7035418b62416cc0.svg";